import React, { useMemo } from 'react'
import { Line } from '@react-three/drei'
import { params } from '../../../../../redux/reducers/reducer';
const OutLineSection = ({ isDeleted, canClone }) => {
    const offset = 0.1;
    const width = 4;
    const height = 3;

    const topLinePoints = useMemo(() => (
            [
                [-(width / 2 + offset), 0.1 + (params.p_r_p - 3) * (-0.2), 0],
                [-(width / 2 + offset), 1, 0],
                [-(width / 2 + offset * 2 ), 1, 0.1],
                [-(width / 2 + offset * 2 ), 1.25, 0.1],
                [-(width / 2 + offset ), 1.25, 0],
                [-(width / 2 + offset ), height + 0.4, 0],
                [-(width / 2 + offset * 7 ), height + 0.4, 0.6],
                [0, 1.95 * height, -width / 2 - 0.1],
                [(width / 2 + offset * 7 ), height + 0.4, 0.6],
                [(width / 2 + offset ), height + 0.4, 0],
                [(width / 2 + offset ), 1.25, 0],
                [(width / 2 + offset * 2 ), 1.25, 0.1],
                [(width / 2 + offset * 2 ), 1, 0.1],
                [(width / 2 + offset), 1, 0],
                [(width / 2 + offset), 0.1 + (params.p_r_p - 3) * (-0.2), 0],
                [(width / 2 + offset), 0.1 + (params.p_r_p - 3) * (-0.2), -width - 0.2],
                [(width / 2 + offset), 1, -width - 0.2],
                [(width / 2 + offset * 2), 1, -width - 0.3],
                [(width / 2 + offset * 2), 1.25, -width - 0.3],
                [(width / 2 + offset ), 1.25, -width - 0.2],
                [(width / 2 + offset ), height + 0.4, -width - 0.2],
                [(width / 2 + offset * 7 ), height + 0.4, -width - 0.8],
                [0, 1.95 * height, -width / 2 - 0.1],
                [-(width / 2 + offset * 7 ), height + 0.4, -width - 0.8],
                [-(width / 2 + offset ), height + 0.4, -width - 0.2],
                [-(width / 2 + offset ), 1.25, -width - 0.2],
                [-(width / 2 + offset * 2), 1.25, -width - 0.3],
                [-(width / 2 + offset * 2), 1, -width - 0.3],
                [-(width / 2 + offset), 1, -width - 0.2],
                [-(width / 2 + offset), 0.1 + (params.p_r_p - 3) * (-0.2), -width - 0.2],
                [-(width / 2 + offset), 0.1 + (params.p_r_p - 3) * (-0.2), 0],
            ]
    ), [params.p_r_p ])

    const roofLinePoints = useMemo(() => (
        [
            [-(width / 2 + offset * 7 ), height + 0.4, 0.6],
            [(width / 2 + offset * 7 ), height + 0.4, 0.6],
            [(width / 2 + offset * 7 ), height + 0.4, -width - 0.8],
            [-(width / 2 + offset * 7 ), height + 0.4, -width - 0.8],
            [-(width / 2 + offset * 7 ), height + 0.4, 0.6],
    
        ]
), [])
    
    return (
        <group position={[0, -0.5, width / 2 + 0.1]} >
            <Line
                points={topLinePoints}
                color={isDeleted ? '#D5121A' : !canClone? "#FD8900" : "#1FAC48"}
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Line
                points={roofLinePoints}
                color={isDeleted ? '#D5121A' : !canClone? "#FD8900" : "#1FAC48"}
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
        </group>
    )
}

export default OutLineSection